<ng-container *transloco="let convert;">
  @if (showBanner) {
    <app-sell-banner (close)="closeBanner()" [bannerConfig]="banner" [translationPath]="translationPath"> </app-sell-banner>
  }

  @if (offer) {
    <article class="sell-offer" [ngClass]="{'box-grey-content':auctionItemStatus !== 'ACTIVE'}">
      <div class="sell-offer__card" [class.globalError]='globalError'>
        <lib-state-indicator [variant]="status.variant"
        [identifier]="'sell_offer_rectangle_status_' + index"></lib-state-indicator>
        <div class="sell-offer__meta" role="alert">
          <p class="text-uppercase fw-bold p-0 mb-1 app-datalist-item-label">
            {{ offer.status === "SELLER_COUNTERED" ? convert('sellModule.offers.offer.textCounterOffer') :
            convert('sellModule.offers.offer.textOfferAmount') }}
          </p>
          <div [id]="'sell_offer_amount_' + index" class="h3 fw-normal mb-0"
            aria-labelledby="offer-amount-label">
            {{ formatCurrency(offer.amount) }}
          </div>
        </div>
        <div class="sell-offer__body">
          <div class="sell-offer__details py-2 px-4">
            <app-datalist-item [identifier]="'sell_offer_bidding_dealer_' + index"
              label="{{convert('sellModule.offers.offer.labelBiddingDealer')}}"
            [value]="showDealershipName ? offer.dealershipName : offer.buyerSmartAuctionId"></app-datalist-item>
            @if (showBuyerUserNameToSeller && offer.userName) {
              <app-datalist-item
                [identifier]="'sell_offer_bidding_user_name_' + index"
              label="{{convert('sellModule.offers.offer.labelBuyer')}}" [value]="offer.userName"></app-datalist-item>
            }
            <app-datalist-item [identifier]="'sell_offer_date_time_' + index"
            label="{{convert('sellModule.offers.offer.labelDateTime')}}" value="{{ offerDate }}"></app-datalist-item>
            <app-datalist-item label="{{convert('sellModule.offers.offer.labelComments')}}"
            [value]="offer.comment ? 'Yes' : 'No'"></app-datalist-item>
          </div>
          <div class="sell-offer__actions">
            <div class="sell-offer__status pe-md-4 py-2 px-2 px-md-4">
              <app-datalist-item label="{{convert('sellModule.offers.offer.labelStatus')}}">
                <strong [id]="'sell_offer_status_' + index"
                  [ngClass]="{ 'lib-offer-text-success': offer.status === 'ACCEPTED' }">{{ convert(status.text)
                }}</strong>
              </app-datalist-item>
            </div>
            @if (!hasActions && canRespondToOffers) {
              <button type="button" data-track-elem="button"
                [attr.data-track-name]="'View History-' + offer.auctionItemUuid" data-track-trigger="drawer"
                class="btn btn-link sell-offer__action py-2"
                [ngClass]="{ 'sell-offer__action--active': 'VIEW_HISTORY' === activeAction }"
                (click)="selectActionTab($event, 'VIEW_HISTORY')">
                <span class="sell-offer__action-inner px-3">{{convert('sellModule.offers.offer.btnViewHistory')}}</span>
              </button>
            }
            @if (hasActions && canRespondToOffers) {
              @for (action of offer.offerActions; track action) {
                <button type="button" data-track-elem="button"
                  [attr.data-track-name]="(action | titlecase) + '-' + offer.auctionItemUuid" data-track-trigger="drawer"
                  class="btn btn-link sell-offer__action py-2"
                  [ngClass]="{ 'sell-offer__action--active': action === activeAction }"
                  (click)="selectActionTab($event, action)" [attr.aria-expanded]="action === activeAction">
                  <span class="sell-offer__action-inner px-2 px-md-4">{{ convert(action | titlecase) }}</span>
                </button>
              }
              <button type="button" data-track-elem="button"
                [attr.data-track-name]="'View History-' + offer.auctionItemUuid" data-track-trigger="drawer"
                class="btn btn-link sell-offer__action py-2"
                [ngClass]="{ 'sell-offer__action--active': 'VIEW_HISTORY' === activeAction }"
                (click)="selectActionTab($event, 'VIEW_HISTORY')" [attr.aria-expanded]="'VIEW_HISTORY' === activeAction">
                <span class="sell-offer__action-inner px-3">{{convert('sellModule.offers.offer.btnViewHistory')}}</span>
              </button>
            }
            @if (!canRespondToOffers) {
              @if (!isAdmin) {
                <div class="sell-offer__action readonly-prompt py-2 py-lg-0">
                  <span class="sell-offer__action-inner px-2 px-md-3">
                    {{ readOnlyPrompt }}
                  </span>
                </div>
              }
              <button type="button" data-track-elem="button"
                [attr.data-track-name]="'View History-' + offer.auctionItemUuid" data-track-trigger="drawer"
                class="btn btn-link sell-offer__action view-history-readonly ms-33"
                [ngClass]="{ 'sell-offer__action--active': 'VIEW_HISTORY' === activeAction }"
                (click)="selectActionTab($event, 'VIEW_HISTORY')">
                <span class="sell-offer__action-inner px-3">{{convert('sellModule.offers.offer.btnViewHistory')}}</span>
              </button>
            }
            @if (!isOfferListsTooltipBodyEmpty) {
              <span class="part-of-shared-list">
                <img class="icon-warning-filled-orange"
                  src="assets/icons/icon-warning-filled/icon-warning-filled-orange.svg" alt="Warning Icon">
                  {{ offerTranslations.partOf }}
                  <app-tooltip [showToolTipAsHtml]="true" [tooltip]="offerListsTooltip" class="hover-tooltip"
                    triggers="click :keydown.escape" [allowOutsideClick]=false>
                  <span [id]="'shared-link-hover'" class="shared-text text-bold">
                    {{ currentListType }}
                  </span>
                </app-tooltip>
              </span>
            }
          </div>
        </div>
      </div>
      @if (activeAction) {
        <div class="sell-offer__drawer">
          <lib-accept [isVisible]="activeAction === 'ACCEPT'" [offer]="offer" [tenantName]="tenantName"
            [inventoryItem]="inventoryItem" (cancel)="activeAction = undefined"
          (action)="handleOfferAction($event)"></lib-accept>
          <lib-history [isVisible]="activeAction === 'VIEW_HISTORY'" [tenantName]="tenantName"
            [inventoryItem]="inventoryItem" [offer]="offer" [index]="index" (closed)="activeAction = undefined"
          [showBuyerUserNameToSeller]="showBuyerUserNameToSeller"></lib-history>
          <lib-counter [isVisible]="activeAction === 'COUNTER'" [tenantName]="tenantName" [offer]="offer"
            [inventoryItem]="inventoryItem" (cancel)="activeAction = undefined"
          (action)="handleOfferAction($event)"></lib-counter>
          <lib-decline [isVisible]="activeAction === 'DECLINE'" [tenantName]="tenantName" [offer]="offer"
            [inventoryItem]="inventoryItem" (cancel)="activeAction = undefined"
          (action)="handleOfferAction($event)"></lib-decline>
          <lib-revive [isVisible]="activeAction === 'REVIVE'" [tenantName]="tenantName" [offer]="offer"
            [inventoryItem]="inventoryItem" (cancel)="activeAction = undefined"
          (action)="handleOfferAction($event)"></lib-revive>
          <lib-withdraw [isVisible]="activeAction === 'WITHDRAW'" [tenantName]="tenantName" [offer]="offer"
            [inventoryItem]="inventoryItem" (cancel)="activeAction = undefined"
          (action)="handleOfferAction($event)"></lib-withdraw>
          <button class="drawer__close" [attr.aria-label]="convert('sellModule.offers.offer.ariaLabelCloseDrawer')"
            (click)="activeAction = undefined" data-track-elem="icon" data-track-name="Close" data-track-trigger="close">
            <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
          </button>
        </div>
      }
    </article>
  }
  @if (withdrewOffer) {
    <div class="visually-hidden" role="alert">Offer Withdrawn</div>
  }
  @if (declinedOffer) {
    <div class="visually-hidden" role="alert">Offer Declined</div>
  }
  @if (acceptOffer) {
    <div class="visually-hidden" role="alert">Offer Accepted</div>
  }
  @if (reviveOffer) {
    <div class="visually-hidden" role="alert">Offer Revived</div>
  }
  @if (counterOffer) {
    <div class="visually-hidden" role="alert">Offer Countered</div>
  }
</ng-container>
